import { render, staticRenderFns } from "./BuildingInvestPlanTab.vue?vue&type=template&id=56cd7a04&scoped=true"
import script from "./BuildingInvestPlanTab.vue?vue&type=script&lang=js"
export * from "./BuildingInvestPlanTab.vue?vue&type=script&lang=js"
import style0 from "./BuildingInvestPlanTab.vue?vue&type=style&index=0&id=56cd7a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd7a04",
  null
  
)

export default component.exports